module.exports = __webpack_public_path__ + "media/assets/images/tour/2_Tour_2-513dc403f5ad9824b5d3505a496e4dca.png";